import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { Provider } from 'react-redux'
import Store from './store'
import './index.css';
import AdminPage from './pages/AdminPage';
import { restoreSession } from './slices/userSlice';
import Login from './pages/FlagLoginPage';
import Layout from './pages/LayoutPage';
import Home from './pages/HomePage';
import Game from './pages/GamePage';
import House ,{ loader as houseLoader } from './pages/House';
import reportWebVitals from './reportWebVitals';
import ForgotPassword from './pages/ForgotPassword'
import FlagRankPage from './pages/FlagRankPage';
import TeamFlagsPage from './pages/TeamFlagsPage';
import ScoresPage from './pages/ScoresPage';

const router = createBrowserRouter([
  {path:'/admin',element:<AdminPage />},
  {
    path:'/',
    element: <Layout />,

    children: [
      {
        index: true,
        element: <Home />
      },
      {
        path: '/game',
        element: <Game />
      },
      {
        path: '/house/:team',
        loader: houseLoader,
        element: <House />
      }
    ]
  },
  {
    path: 'login',
    element: <Login />
  },
  {
    path: 'forgot-password',
    element: <ForgotPassword />
  },
  {
    path: 'flag-rank',
    element: <FlagRankPage />
  },
  {
    path: 'flag-rank',
    element: <TeamFlagsPage />
  },
  {
    path: 'score-board',
    element: <ScoresPage />
  }
  
])


async function start() {
await Store.dispatch(restoreSession());
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={Store}>
    <RouterProvider router={router} />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
}
start();
